import React from "react";
import MenuModel from "../../Models/MenuModel";

function MenuCircle({
  element,
  name,
  props,
  IMG_URl,
}: {
  element: MenuModel;
  name: keyof MenuModel;
  props: any;
  IMG_URl: string;
}) {
  return (
    <div
      key={element.id}
      className={`relative flex flex-col items-center gap-1 cursor-pointer ${
        element.id == props.selectedMenu ? "menu-active" : ""
      }  `}
      onClick={() =>
        element.id !== props.selectedMenu ? props.onClickMenu(element.id) : null
      }
    >
      <img
        alt={element.name_en}
        src={`${IMG_URl}${element.image}`}
        className={`max-w-28  w-28 h-28 rounded-50H object-cover ${
          props.selectedMenu ? "max-w-16 !w-16 h-16 max-h-16" : ""
        }`}
      />
      <p
        className={`text-sm font-bold text-center text-onBackground ${
          props.selectedMenu ? "text-xs !text-onBackground" : ""
        } ${element.id == props.selectedMenu ? "!text-onPrimary" : ""}`}
      >
        {element[name]}
      </p>
    </div>
  );
}

export default MenuCircle;
